import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import UserContext from "../contexts/UserContext";
import FetchUtil from "../utils/FetchUtil";
import { useNavigate } from "react-router-dom";

let productOptions = [];
let subsidiaryOptions = [];

function SubsidiaryProductTableRow({ index, userSubsidiaries, handleSubmit, setError, t, setAdd, oddIdx }) {
	const navigate = useNavigate();
	const [userSubsidiaryLoaded, setUserSubsidiaryLoaded] = useState(false);
	const [userSubsidiarySelected, setUserSubsidiarySelected] = useState({ name: "subsidiaryKey", label: "", value: 0 });
	const [productLoaded, setProductLoaded] = useState(false);
	const [productSelected, setProductSelected] = useState({ name: "locationKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const [isProductLoading, setIsProductLoading] = useState(false);
	const userCtx = useContext(UserContext);
	
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		setUserSubsidiaryValues(userSubsidiaries);
	}, []);

	function setUserSubsidiaryValues(subsidiaryObj) {
		let subsidiaryValue = {};
		subsidiaryOptions = [];
		if (subsidiaryObj && subsidiaryObj.length > 0) {
			subsidiaryObj.map((aSubsidiary, idx) => {

				subsidiaryValue.label = aSubsidiary.companyName;
				subsidiaryValue.value = aSubsidiary.companyId;
				subsidiaryOptions.push(subsidiaryValue);
				subsidiaryValue = {};
			});
			setUserSubsidiaryLoaded(true);
		}
	}
	const subsidiaryHandler = (selectedOption, action) => {
		let subsidiaryKey = selectedOption ? selectedOption.value : 0;
		let subsidiaryLabel = selectedOption ? selectedOption.label : "";
		setUserSubsidiarySelected({ ...userSubsidiarySelected, label: (subsidiaryLabel), value: subsidiaryKey });
		fetchSubsidiaryProducts(subsidiaryKey);
	}
	const productHandler = (selectedOption, action) => {
		let companyProductKey = selectedOption ? selectedOption.value : 0;
		let productName = selectedOption ? selectedOption.label : "";
		productSelected.value = companyProductKey;
		setProductSelected({ ...productSelected, label: (productName), value: companyProductKey });
	}
	function fetchSubsidiaryProducts(subsidiaryKey) {
		setError("");
		if (!subsidiaryKey || subsidiaryKey === 0) {
			return;
		}

		setIsProductLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				companyId: subsidiaryKey,
				userCompanyId : userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetCompanyProduct", "/Service/CompanyService/GetCompanyProduct", requestOptions, retrieveCompanyProductSuccess, retrieveCompanyProductFail);
		} catch (error) {
			setIsProductLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveCompanyProductFail(redirect) {
		setIsProductLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getProdFailed"));
	}

	function retrieveCompanyProductSuccess(responseData) {
		let getCompanyProductResponse;
		if (responseData) {
			getCompanyProductResponse = responseData.getCompanyProductResponse;
			if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "0") {
				setProductValues(getCompanyProductResponse.products.slice())
			} else if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getCompanyProductResponse) {
				setError(t("error.error") + " " + getCompanyProductResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsProductLoading(false);
	}

	function setProductValues(productObj) {
		let productValue = {};
		productOptions = [];
		productOptions.push({ label: "", value: 0 });
		if (productObj && productObj.length > 0) {
			productObj.map((aProduct, idx) => {
				productValue.label = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
				productValue.value = aProduct.companyProductKey;
				productOptions.push(productValue);
				productValue = {};
			});
			setProductLoaded(true);
		}
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			companyProductKey: productSelected.value,
			subsidiaryCompanyId: userSubsidiarySelected.value
		};

		if (!userSubsidiarySelected.value || userSubsidiarySelected.value === 0) {
			setError(t("error.subsidiaryReqd"));
			setIsSubmit(false);
		} else if (!productSelected.value || productSelected.value === 0) {
			setError(t("error.prodName.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userSubsidiaryLoaded ? <Select
					name="subsidiaryKey"
					options={subsidiaryOptions}
					onChange={subsidiaryHandler}
					placeholder={""}
					value={userSubsidiarySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="subsidiaryKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{productLoaded ? <Select
					name="companyProductKey"
					options={productOptions}
					onChange={productHandler}
					placeholder={""}
					value={productSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="locationKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(productOptions && productOptions.length >0 && subsidiaryOptions && subsidiaryOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default SubsidiaryProductTableRow;